import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)`
  vertical-align: middle;
  margin-top: -2%;
`;
const PreviewBadge = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: "info" }, t("badges.preview"));
};
export default PreviewBadge;
